import React from 'react';
import PropTypes from 'prop-types';
import { Main, NextScript } from 'next/document';

const DocumentBody = ({ children }) => (
  <body>
    <Main />
    <NextScript />
    {children}
  </body>
);

DocumentBody.propTypes = {
  children: PropTypes.object.isRequired
};

export default DocumentBody;
